// extracted by mini-css-extract-plugin
export default {"login-page":"login_login-page__BeFk1","login-form":"login_login-form__5hahy","login-form-button":"login_login-form-button__r5LZr"};